import React from 'react';
import { SvgIcon } from '../SvgIcon/SvgIcon.esm.js';

const ExclamationCircleIcon = ({ ...props }) => {
    return (React.createElement(SvgIcon, { ...props, viewBox: "0 0 16 16" },
        React.createElement("path", { d: "M8 0.5C3.59869 0.5 0.5 3.5498 0.5 7.75391V8.2461C0.5 12.4512 3.59869 15.5 8 15.5C12.4013 15.5 15.5 12.4502 15.5 8.2461V7.75391C15.5 3.54858 12.4014 0.5 8 0.5ZM7.52429 4.58594H8.47571C8.73224 4.58594 8.93396 4.8147 8.91248 5.0813L8.69129 7.82349C8.67219 8.06006 8.48237 8.24219 8.25452 8.24219H7.74549C7.51765 8.24219 7.32783 8.06006 7.30872 7.82349L7.08753 5.0813C7.06605 4.8147 7.26776 4.58594 7.52429 4.58594ZM8 11.4141C7.44769 11.4141 7 10.9663 7 10.4141C7 9.86181 7.44769 9.41406 8 9.41406C8.55231 9.41406 9 9.86181 9 10.4141C9 10.9663 8.55231 11.4141 8 11.4141Z" })));
};

export { ExclamationCircleIcon };
//# sourceMappingURL=ExclamationCircleIcon.esm.js.map
